import useDocumentTitle from "../../../hooks/useDocumentTitle";
import { Box, Stack } from "@mui/material";
import TopBar from "../../../components/TopBar";
import ProductsTable from "../components/ProductsTable";
import ProductsListPageActions from "../components/ProductsListPageActions";
import ProductsListFilters from "../components/ProductsListFilters";
import useProductFilters from "../components/ProductsFilterHelper";

function ProductListPage() {
  useDocumentTitle("Product List");

  const filters = [
    {
      type: "search",
      options: [
        {
          key: "name",
          placeholder: "Name",
        },
      ],
    },
  ];

  const {
    selectedFilter,
    searchTerm,
    currentQuery,
    handleFilterChange,
    handleSearchChange,
    handleSearchKeyPress,
    handlePaginationChange,
  } = useProductFilters();

  return (
    <Stack direction="column" sx={{ mt: "-1rem" }}>
      <TopBar title="Products/Services">
        <ProductsListPageActions />
      </TopBar>
      <Box mb={2}>
        <ProductsListFilters
          filters={filters}
          selectedFilter={selectedFilter}
          onFilterChange={handleFilterChange}
          onSearchChange={handleSearchChange}
          onSearchKeyPress={handleSearchKeyPress}
          searchTerm={searchTerm}
        />
      </Box>
      <ProductsTable
        handlePaginationChange={handlePaginationChange}
        searchQuery={currentQuery}
      />
    </Stack>
  );
}

export default ProductListPage;
